export * from './breabcrumb';
export * from './recommended';
export * from './filterbar';
export * from './nearlylinks';
export * from './search-by-options';
export * from './propertyListSection';
export * from './propertydetailSection';
export * from './linkHits';
export * from './linkRecommended';
export * from './LeaveYourRequirement';
export * from './nearbyPropertyList';
export * from './projectDetailSection';
export * from './googleAd';
export * from './footer';
export { default as NewFooterMobile } from './newFooterMobile';
export { default as LocationSection } from './LocationSection';

export { default as PropertyLocationSection } from './PropertyLocationSection';
export * from './LeaveYourRequirement';
export * from './search-by-options';
export * from './linkHits';
export * from './NewsArticleSection';
export { default as SEOSection } from './SEOSection/index'; 